module.exports = __webpack_public_path__ + "static/media/LatestLogo.c2d21eb4.jpg";